import React, { Fragment, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { PATH_ARRAYS } from "../../utils/constants";

import Header from "../Header";

const Main = (props) => {
  const location = useLocation();
  const pageRef = useRef(null);

  const isAuthentication = window.location.pathname;

  const authRoute = PATH_ARRAYS.some((key) => isAuthentication.includes(key));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    const node = pageRef.current;
    if (!node) return;

    node.classList.remove("sy-page-enter");
    void node.offsetWidth;
    node.classList.add("sy-page-enter");
  }, [location.pathname]);

  return (
    <Fragment>
      {!authRoute && <Header />}
      <div ref={pageRef} className="sapphire-app-page-container sy-page-enter">
        {props.children}
      </div>
    </Fragment>
  );
};

export default Main;
